export enum LoginType{
   MicrosoftSSOLogin,
   NormalLogin
}

